import type { ReportSettings } from "@/types";
import { computed, ref, watch, type Ref } from "vue";

const settings = ref<ReportSettings>({});

export const useReportSettingsController = (
  initSettings: Ref<ReportSettings | undefined>
) => {
  watch(
    () => initSettings.value,
    (newSettings) => {
      settings.value = newSettings ? { ...newSettings } : {};
    },
    {
      immediate: true,
    }
  );

  const update = (path: string, value: any) => {
    if (!settings.value) return;
    const keys = path.split(".");
    let current: any = settings.value;

    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i];
      if (!(key in current) || typeof current[key] !== "object") {
        current[key] = {};
      }
      current = current[key];
    }

    current[keys[keys.length - 1]] = value;
  };

  return { settings, update };
};

export const useUpdateTemplateSettings = (
  initSettings: Ref<ReportSettings | undefined>,
  updateFn: (settings: ReportSettings) => void
) => {
  const isChanges = computed(() => {
    return (
      JSON.stringify(initSettings.value) !== JSON.stringify(settings.value)
    );
  });

  const submit = () => {
    if (!settings.value) return;
    updateFn(settings.value);
  };

  return { submit, settings, isChanges };
};
